import React, { Component } from 'react';
import {DesmyButton, DesmyState, DesmyModalHandler, DesmyToast, DesmyAxiosService, DesmyAuth } from 'desmy-react';
import axios from 'axios';
import { RequestResponse } from './sharedProps';
interface ActionsProps {
  showPrevButton?: boolean;
  onPrevAction: () => void;
  onNextAction: () => void;
  hasRequest?: boolean;
  showResetAction?:boolean
  label?:string
  step?: number;
}

interface ActionsState {
  hasRequest: boolean;
  modal?: React.ReactNode;
}
class Actions extends Component<ActionsProps, ActionsState> {
  constructor(props: ActionsProps) {
    super(props);
    this.state = {
      hasRequest: false,
    };
  }
  handleOnRestartApplication = () => {
  this.setState({
    modal: (
      <DesmyModalHandler
        settings={{ btnPosition: "OK", btnNegative: "Cancel", loading:true, loadinghint:"Please wait.....Restarting application proccess"}}
        onClose={(state) => {
          if (state.status) {
            this.handleRestartRequest();
          }
          this.setState({ modal: null });
        }}
      >
        <div className="flex flex-col text-sm w-full h-fullpy-2">
         
          <div className="w-full px-4 py-2 space-y-3 rounded-lg font-semibold bg-red-200 text-red-500">
            <div>This will restart your entire application process.</div>
            <div>All previously entered data may be lost.</div>
            <div>Do you want to continue?</div>
          </div>
         
        </div>
      </DesmyModalHandler>
    ),
  });
};
handleRestartRequest = async () => {
  if (this.state.hasRequest) return;

  this.setState({ hasRequest: true });

  try {
    const response = await new DesmyAxiosService().post<RequestResponse>(`/application/data/restart-request/`, {}, {
      headers: {
        "X-CSRFToken": `${DesmyAuth.getCookie('csrftoken')}`,
        "Authorization": `Token ${DesmyAuth.get(DesmyState.APPLICATION_ACCESS_TOKEN)}`,
      },
    });

    if (response.data.success) {
      DesmyToast.success(response.data.message || "Application restarted successfully");
      DesmyAuth.logoutApplication();
      window.location.assign("/application/auth/")
    } else {
      DesmyToast.error(response.data.message || "Failed to restart application");

      if (response.data?.is_login_requires) {
       window.location.assign("/application/auth")
      }
    }

  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === 401) {
      window.location.assign("/application/auth")
    } else {
      DesmyToast.error("Something went wrong. Please try again.");
    }
  } finally {
    this.setState({ hasRequest: false });
  }
};
  render() {
    const { showPrevButton, onPrevAction, onNextAction,showResetAction, hasRequest,label } = this.props;

    return (
      <>
      {this.state.modal}
        <div className="flex w-full mt-7 mb-6 lg:mb-5 justify-between lg:px-6 py-3">
          <div>
              {showResetAction && <DesmyButton
                type={DesmyState.SMALL}
                className="bg-red-500 hover:bg-red-700 dark:bg-red-500 uppercase px-6 py-3.5 mr-5"
                onClick={this.handleOnRestartApplication}
                icon={
                  <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6 inline-block lg:mr-1" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                  </svg>
                }
                hasRequest={this.state.hasRequest}
                label="Restart Application"
              />}
          </div>
          <div>
            {showPrevButton && (
              <DesmyButton
                type={DesmyState.SMALL}
                className="bg-red-500 dark:bg-red-500 uppercase px-6 py-3.5 mr-5"
                onClick={onPrevAction}
                icon={
                  <svg viewBox="0 0 512 512" fill="currentColor" className="w-6 h-6 inline-block lg:mr-1">
                    <path
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="square"
                      strokeMiterlimit={10}
                      strokeWidth={48}
                      d="M244 400L100 256l144-144M120 256h292"
                    />
                  </svg>
                }
                hasRequest={this.state.hasRequest}
                label="Back"
              />
            )}

            <DesmyButton
              type={DesmyState.SMALL}
              className="uppercase px-6 py-3.5 mr-5"
              onClick={onNextAction}
              icon={
                <svg viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6 inline-block lg:mr-1">
                  <path d="M11.293 17.293l1.414 1.414L19.414 12l-6.707-6.707-1.414 1.414L15.586 11H6v2h9.586z" />
                </svg>
              }
              hasRequest={hasRequest}
              label_request="Please wait"
              label={label ?? "Proceed"}
            />
            </div>
        </div>
      </>
    );
  }
}

export default Actions